export default "__VITE_PUBLIC_ASSET__15424ffc__"